import { render, staticRenderFns } from "./FiltersEdit.vue?vue&type=template&id=da6b635a&scoped=true"
import script from "./FiltersEdit.vue?vue&type=script&lang=js"
export * from "./FiltersEdit.vue?vue&type=script&lang=js"
import style0 from "./FiltersEdit.vue?vue&type=style&index=0&id=da6b635a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b635a",
  null
  
)

export default component.exports